// Dynamische H5-Textgenerierung anhand von relationship und occasion aus der URL
export function buildIntroTextFromSearch(search: string): string {
    const p = new URLSearchParams(search);
    const relationship = normalizeRelationship(p.get("relationship"));
    const occasion = normalizeOccasion(p.get("occasion"));

    const base = "Teile uns ein paar Eckdaten über die beschenkte Person mit und wir liefern dir Inspirationen!";

    if (relationship && occasion) {
        return `Du suchst ein Geschenk für ${relationship} zu ${occasion}? ${base}`;
    }
    if (relationship) {
        return `Du suchst ein Geschenk für ${relationship}? ${base}`;
    }
    if (occasion) {
        return `Du suchst Geschenkideen zu ${occasion}? ${base}`;
    }
    // Fallback (Originaltext)
    return "Du bist auf der Suche nach einer Geschenkidee? Teile uns ein paar Eckdaten über die zu beschenkende Person mit und wir liefern dir Inspirationen!";
}

function normalizeRelationship(value: string | null): string | undefined {
    if (!value) return undefined;
    switch (value.trim().toUpperCase()) {
        case "PARTNER":
            return "deinen Partner";
        case "FRIEND":
            return "einen Freund oder eine Freundin";
        case "BROTHER":
            return "deinen Bruder";
        case "SISTER":
            return "deine Schwester";
        case "SIBLING":
            return "dein Geschwister";
        case "MOTHER":
            return "deine Mutter";
        case "FATHER":
            return "deinen Vater";
        case "SON":
            return "deinen Sohn";
        case "DAUGHTER":
            return "deine Tochter";
        case "CHILD":
            return "dein Kind";
        case "COLLEAGUE":
            return "eine Kollegin oder einen Kollegen";
        default:
            return undefined;
    }
}

function normalizeOccasion(value: string | null): string | undefined {
    if (!value) return undefined;
    switch (value.trim().toUpperCase()) {
        case "BIRTHDAY":
            return "einem Geburtstag";
        case "CHRISTMAS":
            return "Weihnachten";
        case "ANNIVERSARY":
            return "einem Jahrestag";
        case "WEDDING":
            return "einer Hochzeit";
        case "VALENTINE":
            return "Valentinstag";
        case "EASTER":
            return "Ostern";
        case "MOTHERS_DAY":
            return "Muttertag";
        case "FATHERS_DAY":
            return "Vatertag";
        default:
            return undefined;
    }
}